import { useTranslation } from "react-i18next";
import type operation from "../../../../public/locales/en/operation.json";
import { FlattenObject } from "../component/common/ObjectUtils";

const useOperationTranslation = () => {
  const { t } = useTranslation(["operation"]);

  const translate = (field: FlattenObject<typeof operation>, defaultValue?: string) => {
    return t(field, defaultValue);
  };

  return translate;
};

export default useOperationTranslation;
